import React from 'react'
import { CONTACT_2 } from '../../constants/ComapnyInfo'
import { Link } from 'react-router-dom'

export default function HomeOneCTA() {
    return (
        <>
            {/* <!-- cta section start --> */}
            <section className="cta-area theme-bg pt-105 pb-115">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8">
                            <div className="section-header">
                                <h2 className="section-title section-title__white">Need Emergency Solution <br/>
                                    For Cleaning</h2>
                            </div>
                        </div>
                        <div className="col-xl-4 text-right">
                            <div className="cta-right">
                                <p>24/7 Hours</p>
                                <Link to={`telto:${CONTACT_2}`} className="site-btn site-btn__s3">
                                    <span className="icon"><i className="far fa-arrow-right"></i></span>
                                    Contact us
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- cta section end -->    */}
        </>
    )
}
